import { gsap, Linear } from "gsap";

import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';

export class Loader {

	static container = document.querySelector('.loader');

	static showLoader() {
		if ( Loader.container ) {
			Loader.container.classList.add('show');
			Loader.container.classList.add('enter');
		}
	}

	static hideLoader() {

		gsap.registerPlugin(DrawSVGPlugin);

		gsap.set('.squiggle', {
			drawSVG: '0% 0%'
		})

		gsap.to('.squiggle', {
			duration: 1,
			drawSVG: '100%',
			delay: 0.5,
			stagger: {
				each: .5,
				ease: 'none'
			}
		})


		return new Promise((resolve, reject) => {
			if ( Loader.container ) {
				setTimeout( () => {
					document.querySelector('body').classList.remove('loader-shown');
					document.querySelector('html').classList.remove('loader-shown');
					Loader.container.classList.remove('show');
					resolve(true);
				}, 2000);
			} else {
				resolve(true);
			}
		});
	}

}

